import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from '../../hiring/services/hiring.service';
import { UtilityService } from '../../../core/services/utility.service';

// modals
import { ApplyJobModalComponent } from '../../../modals/careers/apply-job-modal/apply-job-modal.component';
import { ApplyWithPinModalComponent } from '../../../modals/careers/apply-with-pin-modal/apply-with-pin-modal.component';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.css']
})
export class JobDetailsComponent implements OnInit {
  viewModel: any = {};
  careerJobFooterMsg: any;
  companyName: string;
  newAuthToken: string = null;
  openModal: boolean = false;
  hideCategoryFromCareersPage: boolean = false;
  link: string;
  reqDetailWait: boolean = false;
  customHTMLHeaderOnCareersSafeHtml: SafeHtml;
  showPIN: boolean = false;
  showSalaryInterval: boolean = false;
  showRequisitionNumberOnExternalATSPosting: boolean = false;
  portalSettings: any = {};
  jobReqID: any;
  jobDetails: any = {};
  subject: any;
  body: any;
  currencySymbol: string;
  oNLogoCo: any;
  logoUrl: string;
  PositionDescSafeHtml: SafeHtml;
  dateFormat: string;
  ignoreLogout: boolean = false;

  constructor(portalSettingsService: PortalSettingsService, private hiringService: HiringService, private ngbModalService: NgbModal, private utilityService: UtilityService, private route: ActivatedRoute, private router: Router,
    private sanitizer: DomSanitizer) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.dateFormat = utilityService.getDateFormat().toUpperCase();
  }

   ngOnInit(): void {
    this.careerJobFooterMsg = this.portalSettings.CareerJobFooterMsg.ConfigValue;
    this.companyName = this.portalSettings.CareerJobCompanyName.ConfigValue;
    this.openModal = false;
    const customHeader = this.portalSettings.CustomeHTMLHeaderOnCareers.ConfigValue;
    this.customHTMLHeaderOnCareersSafeHtml = customHeader ? this.sanitizer.bypassSecurityTrustHtml(customHeader) : null;
    this.hideCategoryFromCareersPage = this.portalSettings.HideCategoryFromCareersPage.ConfigValue == '1';
    this.link = window.location.href.replace("#", "%23");
    this.reqDetailWait = true;
    this.showPIN = this.portalSettings.ShowInviteWithPin.ConfigValue == "1";
    this.showSalaryInterval = this.portalSettings.ShowSalaryIntervalJobDetails.ConfigValue == "1";
    this.showRequisitionNumberOnExternalATSPosting = this.portalSettings.ShowRequisitionNumberOnExternalATSPosting.ConfigValue == "1";
     this.currencySymbol = this.utilityService.getCurrencySymbol(null);
    this.oNLogoCo = this.portalSettings.OnboardingLogoCo.ConfigValue;
    this.init();
  }

  applyJob() {
    let modalRef = this.ngbModalService.open(ApplyJobModalComponent, { size: 'lg', keyboard: true, backdrop: 'static' });
    modalRef.componentInstance.data = this.jobDetails;
      modalRef.componentInstance.sourceData = {
        source: this.viewModel?.source ?? null,
        jtochash: this.viewModel?.jtochash ?? null,
        jtocprof: this.viewModel?.jtocprof ?? null
      };
    modalRef.componentInstance.name = name;
  }

  applyWithPin() {
    let modalRef = this.ngbModalService.open(ApplyWithPinModalComponent, { size: 'md', keyboard: true, backdrop: 'static' });
    modalRef.componentInstance.data = this.jobDetails;
  }

  print() {
    window.print();
  }

  backToJobListings() {
    if (this.ignoreLogout) {
      this.utilityService.isLoggedOut = true;
      window.location.href = '/Careers/BrowseJobs';
    }
    else {
      this.router.navigate(['/careers/browsejobs']);
    }
  }

  private init() {
    var reqID = '', openModal = '', newAuthToken = '', source = '', jtochash = '', jtocprof = '';

    this.route.params.subscribe(params => {
      if (params) {
        reqID = params['reqID'];
      }
    });

    this.route.queryParams.subscribe(params => {
      if (params) {
        openModal = params['openModal'];
        newAuthToken = params['newAuthToken'];
        source = params['source'];
        jtochash = params['jtochash'];
        jtocprof = params['jtocprof'];
        this.logoUrl = params['logoUrl'];
      }
    });

    var viewModel;
    if (reqID || openModal || newAuthToken || source || jtochash || jtocprof) {
      viewModel = {
        reqID: reqID || null,
        openModal: openModal || null,
        newAuthToken: newAuthToken || null,
        source: source || null,
        jtochash: jtochash || null,
        jtocprof: jtocprof || null
      }
    }

    this.viewModel = viewModel;
    if (viewModel == null || viewModel.reqID == null || viewModel.reqID == "") {
      this.getRouteData();
    }
    else {
      this.jobReqID = viewModel.reqID || null;
      this.openModal = viewModel.openModal == "Y";
      this.newAuthToken = viewModel.newAuthToken || null;
      this.getJobDetail();
    }
  }

  private getRouteData() {
    var queryparams = new URLSearchParams(window.location.search);
    this.ignoreLogout = queryparams.get('ignoreLogout') == 'true';
    //Route data
    var path = window.location.hash;
    if (path != null && path.length > 1) {
      var routeRegex = /#[/]ReqID[=]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/]openModal[=](Y|N)[/]NewAuthToken[=]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/i;
      var routeMatch = routeRegex.exec(path);
      if (routeMatch != null) {
        this.jobReqID = routeMatch[1];
        this.openModal = routeMatch[2] == "Y";
        this.newAuthToken = routeMatch[3];
        this.getJobDetail();
      } else {
        var routeRegex2 = /#[/]ReqID[=]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/]openModal[=](Y|N)/i;
        var routeMatch2 = routeRegex2.exec(path);
        if (routeMatch2 != null) {
          this.jobReqID = routeMatch2[1];
          this.openModal = routeMatch2[2] == "Y";
          this.getJobDetail();
        }
        else {
          var routeRegex3 = /#ReqID[=]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})[/]openModal[=](Y|N)[/]NewAuthToken[=]([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/i;
          var routeMatch3 = routeRegex3.exec(path);
          if (routeMatch3 != null) {
            this.jobReqID = routeMatch3[1];
            this.openModal = routeMatch3[2] == "Y";
            this.newAuthToken = routeMatch3[3];
            this.getJobDetail();
          }
          else {
            var routeRegex4 = /#ReqID[=]([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})[/]openModal[=](Y|N)/i;
            var routeMatch4 = routeRegex4.exec(path);
            if (routeMatch4 != null) {
              this.jobReqID = routeMatch4[1];
              this.openModal = routeMatch4[2] == "Y";
              this.getJobDetail();
            }
          }
        }
      }
    }
  }

  private getJobDetail() {
    this.hiringService.getReqDetailsByIdAndAuthToken(this.jobReqID, this.newAuthToken).then((response: any) => {
      if (response != null) {
        this.jobDetails = response;
        this.jobDetails.DatePostedDisplay = moment.utc(this.jobDetails.DatePosted).format(this.dateFormat);
        this.jobDetails.PositionDesc = this.jobDetails.PositionDesc;
        this.jobDetails.PositionRequirements = this.jobDetails.PositionRequirements;
        this.jobDetails.PositionNotes = this.jobDetails.PositionNotes;
        this.jobDetails.PositionInstructions = this.jobDetails.PositionInstructions;
        this.subject = this.companyName + " Job Posting - " + this.jobDetails.PositionTitle;
        this.body = "Here's an open position from the " + this.companyName + " job posting: " + encodeURIComponent(window.location.href);
        this.reqDetailWait = false;
        if (this.openModal && this.jobDetails.IsApplyOnline)
          this.applyJob();
      }
    });
  }
}
